// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"1c7bbeaf","787":"2fb1cf7c"}[chunkId] + ".chunk.css";
};